import React, { useEffect, useState } from "react";
import CoveoLoadCartTap from "./Commerce/CoveoReduxCartChainTap";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain as loadCurrentCartChain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { HasCoveoHooks, withCoveoHooks } from "./Contexts/CoveoHooksContext";
import CoveoPurchaseChainTap from "./Commerce/CoveoReduxPurchaseChainTap";
import { chain as placeOrderChain, DispatchCompletePlaceOrder } from "@NA/Overrides/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

type Props = HasCoveoHooks;

const CoveoCartItems = ({ cart }: Props) => {
    if (typeof window === "undefined") return null;

    const [reduxTapsAreSet, setReduxTapsAreSet] = useState(false)
    const { methods } = cart;

    useEffect(() => {
        if (!methods || reduxTapsAreSet) { return }
        addToChainAfter(loadCurrentCartChain, ExecuteOnSuccessCallback, CoveoLoadCartTap(cart))
        addToChainAfter(placeOrderChain, DispatchCompletePlaceOrder, CoveoPurchaseChainTap(methods))
        setReduxTapsAreSet(true);
    }, [methods])

    return null;
};

export default withCoveoHooks(CoveoCartItems);